import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import { toDisplayValue } from './appsheetFieldUtils';

const DetailRow = ({ label, value }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2">{toDisplayValue(value)}</Typography>
  </Box>
);

const DetailSection = ({ title, children }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
      {title}
    </Typography>
    {children}
  </Box>
);

const SectionCard = ({ title, children }) => (
  <Paper variant="outlined" sx={{ p: 2, height: '100%' }}>
    <DetailSection title={title}>{children}</DetailSection>
  </Paper>
);

const formatBooleanValue = (value) => {
  if (value === null || value === undefined) return 'N/A';
  return value ? 'Yes' : 'No';
};

const formatCurrencyValue = (value) => {
  if (value === null || value === undefined || value === '') return '$0.00';
  const numeric = typeof value === 'number' ? value : Number(String(value).replace(/[^0-9.-]+/g, ''));
  if (!Number.isFinite(numeric)) return '$0.00';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
  }).format(numeric);
};

const AppSheetAccountDetailPanel = ({ account = null, summary = null, isAllAccounts = false, showMrr = true }) => {
  const source = isAllAccounts ? summary : account;
  if (!source) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Select an account to see details.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <SectionCard title="Identity">
            <DetailRow label="Account name" value={source.name} />
            <DetailRow label="BAC" value={source.bac} />
            {!isAllAccounts ? <DetailRow label="Account ID" value={source.id} /> : null}
            <DetailRow label="CCID" value={source.ccid} />
            <DetailRow label="Account position" value={source.position} />
            <DetailRow label="Address" value={source.address || 'N/A'} />
            <DetailRow label="SF Brands" value={(source.brands || []).join(', ') || 'N/A'} />
          </SectionCard>
        </Grid>
        <Grid item xs={12} md={6}>
          <SectionCard title="Status">
            <DetailRow label="Account status" value={source.status} />
            <DetailRow label="In production" value={formatBooleanValue(source.inProduction)} />
            <DetailRow label="Website enrollment" value={formatBooleanValue(source.websiteEnrollment)} />
            {showMrr ? <DetailRow label="MRR" value={formatCurrencyValue(source.mrr)} /> : null}
          </SectionCard>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AppSheetAccountDetailPanel;
